import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

export const SelectedToolTip = withStyles(() => ({
    tooltip: {
        classKey: 'selected-tooltip',
        backgroundColor: '#D4EDDA !important',
        color: '#155724 !important',
        display: 'flex',
        alignItems: 'center',
        fill: '#155724 !important'
    },
    arrow: {
        color: "#D4EDDA !important",
    },
    popper: {
        zIndex: 999
    }
}))(Tooltip);
